export default __webpack_public_path__ + "static/media/anant-bg.2116d03a.mp4";